"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { DecisionPoint } from "@/helpers/waves/time.types";
import { HorizontalTimeline } from "./HorizontalTimeline";
interface ExpandedTimelineContentProps {
  readonly decisions: DecisionPoint[];
  readonly nextDecisionTime: number | null;
  readonly onLoadMorePast?: () => void;
  readonly onLoadMoreFuture?: () => void;
  readonly hasMorePast?: boolean;
  readonly hasMoreFuture?: boolean;
  readonly remainingPastCount?: number | null;
  readonly remainingFutureCount?: number | null;
  readonly focus?: "start" | "end" | null;
  readonly onFocusHandled?: () => void;
}
export const ExpandedTimelineContent: React.FC<ExpandedTimelineContentProps> = t0 => {
  const $ = _c(21);
  const {
    decisions,
    nextDecisionTime,
    onLoadMorePast,
    onLoadMoreFuture,
    hasMorePast: t1,
    hasMoreFuture: t2,
    remainingPastCount: t3,
    remainingFutureCount: t4,
    focus: t5,
    onFocusHandled
  } = t0;
  const hasMorePast = t1 === undefined ? false : t1;
  const hasMoreFuture = t2 === undefined ? false : t2;
  const remainingPastCount = t3 === undefined ? null : t3;
  const remainingFutureCount = t4 === undefined ? null : t4;
  const focus = t5 === undefined ? null : t5;
  const [animationComplete, setAnimationComplete] = useState(false);
  const earliestDecisionIndex = hasMorePast && decisions.length > 0 ? decisions[0]?.seriesIndex ?? null : null;
  const pastCountToDisplay = remainingPastCount != null && remainingPastCount > 0 ? remainingPastCount : earliestDecisionIndex;
  const formatLabel = _temp;
  let t10;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      height: 0,
      opacity: 0
    };
    t7 = {
      height: "auto",
      opacity: 1
    };
    t8 = {
      height: 0,
      opacity: 0
    };
    t9 = {
      duration: 0.3
    };
    t10 = () => setAnimationComplete(true);
    $[0] = t10;
    $[1] = t6;
    $[2] = t7;
    $[3] = t8;
    $[4] = t9;
  } else {
    t10 = $[0];
    t6 = $[1];
    t7 = $[2];
    t8 = $[3];
    t9 = $[4];
  }
  let t11;
  if ($[5] !== hasMoreFuture || $[6] !== hasMorePast || $[7] !== onLoadMoreFuture || $[8] !== onLoadMorePast || $[9] !== pastCountToDisplay || $[10] !== remainingFutureCount) {
    t11 = (hasMorePast || hasMoreFuture) && <div className="tw-flex tw-items-center tw-justify-between tw-gap-3 tw-pb-3 tw-text-xs tw-text-iron-300"><div className="tw-flex tw-items-center tw-gap-2">{hasMorePast && onLoadMorePast && <button type="button" onClick={onLoadMorePast} className="tw-inline-flex tw-items-center tw-gap-1.5 tw-rounded-md tw-border tw-border-solid tw-border-iron-800/60 tw-bg-iron-900/60 tw-px-3 tw-py-1.5 tw-text-xs tw-font-semibold tw-leading-4 tw-text-iron-100 tw-shadow-sm tw-transition-all tw-duration-200 tw-ease-out desktop-hover:hover:tw-border-iron-600/70 desktop-hover:hover:tw-bg-iron-700/60 desktop-hover:hover:tw-text-iron-50 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-iron-500"><FontAwesomeIcon icon={faChevronLeft} className="tw-size-4 tw-flex-shrink-0" /><span className="tw-whitespace-nowrap">{formatLabel(pastCountToDisplay, "earlier")}</span></button>}</div><div className="tw-flex tw-items-center tw-gap-2">{hasMoreFuture && onLoadMoreFuture && <button type="button" onClick={onLoadMoreFuture} className="tw-inline-flex tw-items-center tw-gap-1.5 tw-rounded-md tw-border tw-border-solid tw-border-iron-800/60 tw-bg-iron-900/60 tw-px-3 tw-py-1.5 tw-text-xs tw-font-semibold tw-leading-4 tw-text-iron-100 tw-shadow-sm tw-transition-all tw-duration-200 tw-ease-out desktop-hover:hover:tw-border-iron-600/70 desktop-hover:hover:tw-bg-iron-700/60 desktop-hover:hover:tw-text-iron-50 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-iron-500"><span className="tw-whitespace-nowrap">{formatLabel(remainingFutureCount, "later")}</span><FontAwesomeIcon icon={faChevronRight} className="tw-size-4 tw-flex-shrink-0" /></button>}</div></div>;
    $[5] = hasMoreFuture;
    $[6] = hasMorePast;
    $[7] = onLoadMoreFuture;
    $[8] = onLoadMorePast;
    $[9] = pastCountToDisplay;
    $[10] = remainingFutureCount;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== animationComplete || $[13] !== decisions || $[14] !== focus || $[15] !== nextDecisionTime || $[16] !== onFocusHandled) {
    t12 = <HorizontalTimeline decisions={decisions} nextDecisionTime={nextDecisionTime} animationComplete={animationComplete} focus={focus} onFocusHandled={onFocusHandled} />;
    $[12] = animationComplete;
    $[13] = decisions;
    $[14] = focus;
    $[15] = nextDecisionTime;
    $[16] = onFocusHandled;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t11 || $[19] !== t12) {
    t13 = <motion.div initial={t6} animate={t7} exit={t8} transition={t9} onAnimationComplete={t10} className="tw-bg-iron-950"><div className="tw-px-3 tw-py-4">{t11}{t12}</div></motion.div>;
    $[18] = t11;
    $[19] = t12;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  return t13;
};
function _temp(count, direction) {
  if (count == null) {
    return direction === "earlier" ? "Show earlier" : "Show later";
  }
  if (count <= 0) {
    return direction === "earlier" ? "Show earlier" : "Show later";
  }
  const noun = direction === "earlier" ? "earlier" : "later";
  return `Show ${count} ${noun}`;
}